<div class="mt-5">
  <div class="footer justify-content-center">
    <div class="pb-3" id="icamRights">
      <span> &copy; {{ getYear() }} ICAM S.P.A - All rights reserved </span>
    </div>
  </div>
</div>
